export default "__VITE_ASSET__JM0Slk0O__"